import { Component, OnInit } from '@angular/core';
import {
	CustomFormAccessor,
	FormConfig,
} from 'src/shared/form-models/form-cva.component';
import { NgControl, FormBuilder } from '@angular/forms';
import { PrevailingWageRates } from '../prevailing-wage.models';

const prevailingWageRatesFormConfig: FormConfig<PrevailingWageRates> = {
	pw1Rate: [''],
	pw2Rate: [''],
	pw3Rate: [''],
	pw1NightShiftRate: [''],
	pw2NightShiftRate: [''],
	pw3NightShiftRate: [''],
};

@Component({
	selector: 'rpfsa-prevailing-wage-rates',
	templateUrl: './prevailing-wage-rates.component.html',
})
export class PrevailingWageRatesComponent
	extends CustomFormAccessor<PrevailingWageRates>
	implements OnInit {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, prevailingWageRatesFormConfig);
	}
}
